

export default function toCurrency(value){
    if(value){
        const v = parseFloat(String(value).replace(',', '.'));
        
        const format = v.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        

        return (format);

    } else {
        return ('R$ 0,00');
    }
}